module.exports = __webpack_public_path__ + "img/ab.988a1b9e.svg";